import { render } from "./BandejaAprobadasRechazadas.vue?vue&type=template&id=13f68a37"
import script from "./BandejaAprobadasRechazadas.vue?vue&type=script&lang=js"
export * from "./BandejaAprobadasRechazadas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__